import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import CategoryGrid from "@/sections/CategoryGrid";
import BestSellers from "@/sections/BestSellers";
import WhyUs from "@/sections/WhyUs";
import Featured from "@/sections/Featured";
import Reviews from "@/sections/Reviews";
import LifestyleBanner from "@/sections/LifestyleBanner";
import TrustBar from "@/sections/TrustBar";
import Faq from "@/sections/Faq";

export default function Home() {
  const [data, setData] = useState({ categories: [], bestsellers: [], featured: [], reviews: [], faqs: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.categories(),
      api.products({ bestseller: true, limit: 8 }),
      api.products({ featured: true, limit: 4 }),
      api.reviews(),
      api.faqs(),
    ])
      .then(([categories, bestsellers, featured, reviews, faqs]) =>
        setData({ categories, bestsellers, featured, reviews, faqs })
      )
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      {!loading && data.bestsellers.length === 0 && (
        <div className="mx-auto max-w-7xl px-4 py-20 text-center" data-testid="catalog-syncing">
          <p className="font-heading text-xl font-semibold text-neutral-900">Catalog is syncing</p>
          <p className="mt-2 text-sm text-neutral-500">We're connecting to the live store catalog. Please refresh in a moment.</p>
        </div>
      )}
      {!loading && data.bestsellers.length > 0 && (
        <>
          <CategoryGrid categories={data.categories} />
          <BestSellers products={data.bestsellers} />
        </>
      )}
      {!loading && (
        <>
          <WhyUs />
          {data.featured.length > 0 && <Featured products={data.featured} />}
          <Reviews reviews={data.reviews} />
          <LifestyleBanner />
          <TrustBar />
          <Faq faqs={data.faqs} />
        </>
      )}
      {loading && (
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 py-24 sm:grid-cols-4 sm:px-6 lg:px-8" data-testid="home-loading">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="aspect-[4/5] animate-pulse rounded-xl bg-neutral-200/70" />
          ))}
        </div>
      )}
    </main>
  );
}
